import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Alert,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import DescriptionIcon from "@mui/icons-material/Description";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const OverviewTab = () => (
  <Card>
    <CardContent>
      <Typography variant="h5" gutterBottom>
        Welcome to Inbound Checker Management Service
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        The Inbound Checker Management Service helps you automate inbound data
        processing, extraction, and management using Google APIs and modern
        automation tools.
      </Typography>

      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <EmailIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Google Sheets Integration</Typography>
              <Typography variant="body2" color="text.secondary">
                Automatically scan Google Sheets for invoice data
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <DescriptionIcon color="success" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">JTL Fulfillment Center</Typography>
              <Typography variant="body2" color="text.secondary">
                Extract and process sending data automatically
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: "center" }}>
              <CloudUploadIcon color="info" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Cloud Storage</Typography>
              <Typography variant="body2" color="text.secondary">
                Store processed data back to sheets
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Getting Started
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        To start using the Invoice Management Service:
      </Typography>
      <ol style={{ paddingLeft: "20px" }}>
        <li>
          <strong>Set up Google Credentials:</strong> Upload your Google Cloud
          Console credentials file in the "Google Credentials" tab
        </li>
        <li>
          <strong>Configure Scopes:</strong> Select the appropriate Google API
          scopes for your use case (Sheets)
        </li>
        <li>
          <strong>Complete OAuth Flow:</strong> Follow the authorization URL to
          grant permissions
        </li>
        <li>
          <strong>Start Processing:</strong> Begin automated tracking and
          processing
        </li>
      </ol>

      <Alert severity="info" sx={{ mt: 3 }}>
        <Typography variant="body2">
          <strong>Note:</strong> This service integrates with Google APIs to
          provide seamless tracking management. Make sure you have the necessary
          permissions and API quotas configured in your Google Cloud Console.
        </Typography>
      </Alert>
    </CardContent>
  </Card>
);

export default OverviewTab;
